import { INITIAL_CLAIM } from 'src/configs/claims';
import {
  CLAIM_CONTROLS_DBT,
  CLAIM_CONTROL_MULTI_FRAME_POLYGON,
  CLAIM_CONTROL_POLYGON,
} from 'src/configs/claims/controls';
import { ClaimCreateSchema } from 'src/types/api/data/project';

/* eslint-disable no-template-curly-in-string */
const DBTClaim: ClaimCreateSchema = {
  ...INITIAL_CLAIM,
  controls: [
    CLAIM_CONTROL_MULTI_FRAME_POLYGON,
    CLAIM_CONTROL_POLYGON,
    ...CLAIM_CONTROLS_DBT,
  ],
  viewer: {
    type: 'tomosynthesis',
    images: [
      {
        name: 'RCC_2D',
        id: 'RCC_2D._id',
      },
      {
        name: 'LCC_2D',
        id: 'LCC_2D._id',
      },
      {
        name: 'RMLO_2D',
        id: 'RMLO_2D._id',
      },
      {
        name: 'LMLO_2D',
        id: 'LMLO_2D._id',
      },
      {
        name: 'RCC_3D',
        id: 'RCC_3D._id',
      },
      {
        name: 'LCC_3D',
        id: 'LCC_3D._id',
      },
      {
        name: 'RMLO_3D',
        id: 'RMLO_3D._id',
      },
      {
        name: 'LMLO_3D',
        id: 'LMLO_3D._id',
      },
    ],
  },
};

export default DBTClaim;
